/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.16",
    versionName: "0.2.0-nightly.2025.7.16",
    versionChannel: "nightly",
    buildDate: "2025-07-16T00:09:25.778Z",
    commitHash: "ba02cfd9405c718dd3fad69fb446c63cbc7de25e",
};
